import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'sondermind-progress-screen',
  templateUrl: './progress-screen.component.html',
  standalone: false
})
export class ProgressScreenComponent {
  @HostBinding('class.sondermind-progress-screen')
    addClass = true;

  @Input()
    visible: boolean;

  @Input()
    message: string;
}
